import { Separator } from "@/components/ui/separator";
import {
  useMaskableField,
  useRegisterVisibilityField,
} from "@/context/FormFieldVisibilityContext";
import { MASKABLE_FIELD_MINIMIZED_CLASS } from "@/lib/maskable-field-styles";
import { cn } from "@/lib/utils";
import { FieldVisibilityToggle } from "./FieldVisibilityToggle";

type MaskableSeparatorWithTextProps = {
  text: string;
  fieldName: string;
  className?: string;
};

/** Separator label + line, with field visibility toggle aligned to the right. */
export function MaskableSeparatorWithText({
  text,
  fieldName,
  className,
}: MaskableSeparatorWithTextProps) {
  const { enabled, expanded, minimized, canToggle, toggleVisibility } =
    useMaskableField(fieldName);
  // Doesn't render MaskableFieldHeader, so register explicitly for the drawer.
  useRegisterVisibilityField(fieldName, { label: text });

  // Masked → hidden entirely (re-enable it from the field visibility menu).
  if (enabled && minimized) {
    return null;
  }

  return (
    <div className={cn("flex w-full items-center gap-2", className)}>
      <p
        className={cn(
          "shrink-0 whitespace-nowrap text-sm font-['Raleway']",
          minimized ? MASKABLE_FIELD_MINIMIZED_CLASS : "text-slate-700",
        )}
      >
        {text}
      </p>
      <Separator
        className={cn("flex-1", minimized && "opacity-60 bg-muted-foreground/30")}
      />
      {enabled && canToggle && (
        <FieldVisibilityToggle
          expanded={expanded}
          minimized={minimized}
          onToggle={toggleVisibility}
        />
      )}
    </div>
  );
}
